<template>
	<div class="profile-comment">
		<div class="profile-comment__header">
			<o-avatar
				:name="`${comment.authorFirstName} ${comment.authorLastName}`"
				:avatar="comment.authorAvatarId"
				root-url="/app/avatar/"
				size="xs"/>
			<div>
				<p class="profile-comment__name">{{ comment.authorFirstName }} {{ comment.authorLastName }}</p>
				<small class="profile-comment__post-date">
					{{ setup.postedDate }}.
				</small>
			</div>
			<o-icon
				v-if="comment.authorAvatarId === setup.self.avatarId"
				v-tooltip="`Supprimer le commentaire`"
				class="profile-comment__header-action"
				font-icon="icon-interface-delete-bin-2"
				ripple="danger"
				@click="setup.deleteComment(comment.id)"/>
		</div>
		<p class="profile-comment__comment">
			{{ comment.comment }}
		</p>
	</div>
</template>

<script setup lang="ts">
import TempWorkerCommentSetupService from '@/setup/temp-worker/TempWorkerCommentSetupService';
const emits = defineEmits<{(e: 'delete-comment', val: number): void}>();
const props = defineProps(TempWorkerCommentSetupService.props);
const setup = new TempWorkerCommentSetupService(props, emits);
</script>

<style scoped lang="less">
.profile-comment {
	padding: var(--space-xs);
	margin-bottom: var(--space-xs);
	border-radius: 0.25rem;

	&:hover{
		background: rgba(var(--rgb-grey-light) , 0.5);
	}

  &__header {
		position: relative;
    display: flex;
    align-items: center;
    gap: var(--space-xs);
    margin-bottom: var(--space-xs);

		&-action {
      margin: 0.25rem 0.25rem 0 auto;
      align-self: flex-start;
		}

    p {
      font-size: 0.85rem;
      font-weight: 600;
      color: var(--grey-darker);
      margin: 0;
    }

    small {
      display: block;
      color: var(--grey);
    }
  }

  &__comment {
    margin-bottom: 0;
    padding-left: var(--space-xs);
    border-left: calc(1rem / 16) solid var(--grey-light);
  }
}
</style>
